import * as React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as SearchIcon } from 'assets/images/search-icon.svg';
import { Text } from 'ui';
import palette from 'ui/theme/palette';

interface Props {
  searchTerm?: string;
  resultCount?: number;
}

// Owns the entire show/hide decision: renders only when there's an active search
// term and a non-zero result count. Callers can pass props through unconditionally.
export const SearchResultsBanner: React.FC<Props> = ({ searchTerm, resultCount }) => {
  if (!searchTerm || !resultCount) {
    return null;
  }

  const noun = resultCount === 1 ? 'result' : 'results';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: palette.primary.screen,
        border: `1px solid ${palette.primary.mediumLight}`,
        borderRadius: '6px',
        px: 2,
        py: 1,
        mb: 2
      }}
    >
      <SearchIcon style={{ flexShrink: 0, color: palette.primary.main }} />
      <Text type="body3" content={`"${searchTerm}" Found ${resultCount} ${noun}`} />
    </Box>
  );
};
